import { render, staticRenderFns } from "./ReplyTemplatesTable.vue?vue&type=template&id=0dbc6c8c&"
import script from "./ReplyTemplatesTable.vue?vue&type=script&lang=js&"
export * from "./ReplyTemplatesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports